<template>
  <div class="lp-check-container">
    <div class="sel-btn" :class="{'selected': selected === val }" @click="clickCheck">
      <i v-if="selected===val" class="material-icons checked-icon">check</i>
    </div>
    <div class="lp-label">{{ label }}</div>
  </div>
</template>

<script>
  export default {
    props:['selectVal', 'val', 'label', 'right'],
    created() {
      this.selected = this.selectVal;

      // if ( this.selected === this.val ) {
      //   this.isChecked = true;
      // }
      // else if ( this.selected !== this.val ) {
      //   this.isChecked = false;
      // }
    },
    data() {
      return {
        selected: ''
      }
    },
    watch: {
      selectVal(n) {
        this.selected = n;
      }
    },
    methods: {
      clickCheck() {
        if ( this.selected === this.val ) {
          this.selected = '';
        }
        else if ( this.selected !== this.val ) {
          this.selected = this.val;
        }
        this.$emit('update:selectVal', this.selected);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  .lp-check-container
    display flex
    flex-wrap wrap

  .sel-btn
    width 16px
    height 16px
    border-radius 3px
    margin auto 0
    margin-right 8px
    border 1px solid #dddddd
    background-color white
    display inline-block
    text-align center

  .selected
    background-color $primary
    border 1px solid $primary

  .checked-icon
    color #fff
    font-size .8rem
    font-weight bold
    padding 1.5px
    display flex
    align-items center
    justify-content center

  .lp-label
    font-size 0.9rem
    line-height 17px

</style>
